// extracted by mini-css-extract-plugin
module.exports = {"TEXT_CONTAINER":"TextContainer_TEXT_CONTAINER__12gnM"};